<template>
  <div>
    <div class="inside">
      <flickity class="flickity" ref="flickity" :options="flickityOptions">
        <div class="carousel-cell" v-for="stop in stops" v-bind:key="stop.id">
          <StopCard
            :modifier="`stop-card--single`"
            :image="stop.image"
            :title="stop.text.title[currentLang]"
            :stopNumber="stop.text.stopNumber[currentLang]"
            :letterbox="stop.letterbox"
          />
        </div>
      </flickity>
    </div>
    <Player v-show="playerShowing" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import StopCard from "@/components/StopCard";
import Player from "@/components/Player";
import Flickity from "vue-flickity";

export default {
  components: {
    StopCard,
    Player,
    Flickity
  },
  data() {
    return {
      flickityOptions: {
        initialIndex: Number(this.$route.params.id) - 1, //flickity is zero based :)
        prevNextButtons: true,
        pageDots: false,
        wrapAround: false,
        freeScroll: false,
        adaptiveHeight: true
        // any options from Flickity can be used
      }
    };
  },
  computed: {
    ...mapState(["stops", "currentLang", "playerShowing"])
  },
  beforeCreate() {
    // Show the player in viewport.
    this.$store.dispatch("togglePlayer", true);
    // Set play status ON + take ID from route.
  },
  beforeDestroy() {
    this.$refs.flickity.destroy();
  },
  mounted() {
    this.$refs.flickity.on("settle", slideNum => {
      this.$store.dispatch("togglePlaying", {
        id: slideNum + 1
      });

      this.$store.dispatch("toggleIsPlaying", true);
      this.$store.dispatch("updateCurrentStop", slideNum + 1);

      this.$router.push({ name: "stop", params: { id: slideNum + 1 } });
    });
  },
  methods: {
    prev() {
      this.$refs.flickity.previous();
    },
    next() {
      this.$refs.flickity.next();
    }
  }
};
</script>

<style lang="scss" scoped>
.flickity-viewport {
  transform: scale(0.6) translateY(-60px);
}
.carousel-cell {
  width: calc(100% - 20px); /* full width */
  margin-left: 10px;
  margin-right: 10px;
  height: 80vh;
  display: grid;
  align-content: center;
}
.stop-card {
  // min-height: 79.225352%; /* 568:100 / 450: 79.22etc */
  background-color: white;

  &--single {
    display: grid;
    align-items: end;
    // @media screen and (max-height: 700px) {
    //   min-height: 380px;
    // }
  }
}
</style>
